<template>
    <div class="form-group">
      <label for="conf_str">Pending (example: @pendings/alpha_testers_search)</label>
      <input v-model="confStr" id="conf_str" class="form-control" required>
    </div>
</template>

<script>
import { getProtoId } from '../util';

export default {
  name: 'PlayerPendingAddDataInputFollowingLink',

  data() {
    return {
      confStr: '',
    };
  },

  methods: {
    fillFormData(formData) {
      const trimmedConfStr = this.confStr.trim();
      if(trimmedConfStr.length === 0) {
        return new Error('Conf must be specified.');
      }

      const questConfId = getProtoId(trimmedConfStr);
      if(questConfId === null) {
        return new Error(`Conf ${trimmedConfStr} is not found.`);
      }

      formData.append('conf_str', trimmedConfStr);

      return null;
    },
  },
}
</script>